import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Row, Col, Table } from 'react-bootstrap';
import { fetchForApprovals } from '../../store/actions/projects/projectApprovals';

import ProjectApprovalButtons from './ProjectApprovalButtons';

class ProjectApprovals extends Component {

  constructor(props){
    super(props);

    this.confirmAction = '';
    this.projectId = '';
    this.projectName = '';
  }
  componentDidMount() {
    this.props.fetchForApprovals();
  }

  renderApprovals = () => {
    let approvalsList = [];
    
    const forApprovals = this.props.projects.forApprovals;

    if (forApprovals) {
      approvalsList = forApprovals.length > 0 ? ( forApprovals.map((forApproval, key) => {
        return (
          <tr key={key}>
            <td></td>
            <td colSpan={2}>
              <Link to="#" onClick={(e) => {
                e.preventDefault();

                this.props.history.push('/projects/for-approval?id=' + forApproval.id);
              }}>
                {forApproval.project_name}
              </Link>
            </td>
            <td>
              <div className="float-right">
                <ProjectApprovalButtons project={forApproval} inPage={false} />
              </div>
            </td>
          </tr>
        )
      })) : (
        <tr>
          <td colSpan={4}>Loading...</td>
        </tr>
      )
    }
    else {
      approvalsList = (
        <tr>
          <td colSpan={4}>No results found.</td>
        </tr>
      )
    }

    return (
      <>
        <Table hover>
          <thead>
            <tr>
              <th className="approvalCheckbox"></th>
              <th>Project Name</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            { approvalsList }
          </tbody>
        </Table>
      </>
    )
  }

  render() {
    let heading = (
      <>
        <Row>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <h6>Projects</h6>
          </Col>
        </Row>
      </>
    );
    if (this.props.inDashboard) {
      heading = "";
    }

    return (
      <React.Fragment>
        {heading}        
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            { this.renderApprovals() }
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchForApprovals: () => dispatch(fetchForApprovals())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectApprovals))
